var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-sub-header',[_c('div',{staticClass:"header-container"},[_c('dash-icon',{staticClass:"header-icon",attrs:{"icon":_vm.icon,"alt":""}}),_c('div',{staticClass:"header-contents"},[_c('h1',{staticClass:"header-title"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('p',{staticClass:"header-description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }